module.exports = SharedDependencies.React['org_hub_shell'];